
import { Component, Vue } from 'vue-property-decorator';
import { notiSrv } from '@/services/noti';
import SideMenu from '@/components/common/SideMenu.vue';

@Component({
  components: {SideMenu},
})
export default class App extends Vue {
  notis = notiSrv.notis
  constructor(){
    super()
  }
}
